<!--  / sidebar \ -->
<aside [ngClass]="{'hide-sidebar': hideSidebar}">
    <div id="siderbar__overlay" class="d-none"></div>
    <div id="ipjSidebar" class="sidebar hide-on-mobile">
        <a href="javascript:void(0)" class="sidebar__closebtn hide-on-mobile d-flex font-25 link-no-underline "
            onclick="closeNav()">
            <!-- <span class="primary-bg light-color">&lsaquo;</span> -->
            <span class="material-symbols-outlined primary-bg light-color">
                keyboard_double_arrow_left
            </span>
        </a>
        <div class="light-bg sidebar__wrapper">
            <a onclick="closeNavMobile()" class="sidebar--close link-no-underline d-md-none hide-on-desktop"
            [ngClass]="{'hide-sidebar':hideSidebar}">
            <span class="icon-nav font-22" id="iconNavMobile"></span>
            <!-- <span class="icon-close font-25"></span> -->
        </a>
            <div class="sidebar__top d-flex align-items-center ">
                <!-- <img src="assets/images/revamp/sidebar_top-logo.png" alt="Logo" /> -->
                <img style="max-width: 42%;" [src]="user?.partnerInfo?.logo ? user?.partnerInfo?.logo : 'assets/images/upgradRed/upgradEntLoginLogo.png'" alt="Logo" />
            </div>
            <div class="sidebar__user d-flex align-items-center ">
                <div class="sidebar__profile--pic">
                    <img [src]="user?.profilePic ? user?.profilePic : '/assets/images/user.svg'" alt=""
                        class="sidebar__user--img" />
                </div>
                <!-- <img [src]="user?.profilePic ? user?.profilePic : 'assets/images/profile.jpg'" alt=""
                class="sidebar__user--img mg-r10"> -->
                <div class="sidebar__profile--desc pd-l10">
                    <p class="sidebar__user--name dark-color" [title]="[user?.name]">{{user?.name}}</p>

                    <a routerLink="/dashboard/profile" class="sidebar__user--link link-no-underline primary-color">View
                        Profile</a>
                </div>
            </div>
            <div class="leaderboard--name sidebar__tag d-flex align-items-center text-uppercase" *ngIf="isleaderboard">
                <span [ngClass]="{
                        'achiever':(activationInfo?.rankColour == 'Yellow'),
                        'novice':(activationInfo.rankColour == 'Red')
                    }">{{activationInfo['rankStatus']}}</span>
            </div>
            <!-- <div class="sidebar__tag d-flex align-items-center text-uppercase">
                superstar
</div> -->
            <ul class="sidebar__menu list-none">
                <li>
                    <a routerLink="/dashboard" routerLinkActive="active_menu" [routerLinkActiveOptions]="{exact: true}"
                        class="dark-color link-no-underline">
                        <span class="material-symbols-outlined">home_app_logo</span>
                        <span class="sidebar__menu-title">My Dashboard</span>
                    </a>
                </li>
                <li>
                    <a [routerLink]="['habit-drills']" *ngIf="showHabitDrillMenu && !showCustomHabitDrillMenu"
                        routerLinkActive="active_menu" class="dark-color link-no-underline">
                        <span class="material-symbols-outlined">local_library</span>
                        <span class="sidebar__menu-title">Habit Drills</span>
                        </a>
                </li>
                <li>
                    <a [routerLink]="[customHabitDrillMenu]" *ngIf="showHabitDrillMenu && showCustomHabitDrillMenu"
                        routerLinkActive="active_menu" class="dark-color link-no-underline">
                        <span class="material-symbols-outlined">app_badging</span>
                        <span class="sidebar__menu-title">{{customHabitDrillMenu}}</span>
                        </a>
                </li>
                <li>
                    <p>{{storeData?.data?.programActivationId}}</p>
                    <a routerLink="/dashboard/notes-bookmarks" routerLinkActive="active_menu"
                        (click)="captureNotesBookmarksEvent()" class="dark-color link-no-underline">
                        <span class="material-symbols-outlined">collections_bookmark</span>
                        <span class="sidebar__menu-title"> Notes & Bookmarks</span>
                       </a>
                </li>
                <li class="hide-on-mobile" *ngIf="isBotEnabled">
                    <a routerLink="/dashboard/ipj-bot" routerLinkActive="active_menu"
                     class="dark-color link-no-underline">
                        <img style="width: 24px;z-index:1" src="assets/images/generating_response.gif" alt="">
                        <span class="sidebar__menu-title" style="text-transform: none!important;">thriveBOT</span>
                        <div class="sidebar__menu-title-new" *ngIf="isBotEnabled && isBotNewTag">
                            <span >NEW!</span>
                        </div>
                       </a>
                </li>
                <!-- <li>
                    <a routerLinkActive="active_menu" (click)="redirectBusiness()" *ngIf="showHideCoursesTab"
                        class="dark-color link-no-underline d-block">Other Courses/Program</a>
                </li> -->
                <li *ngIf="isleaderboard">
                    <a routerLinkActive="active_menu" routerLink="/dashboard/leaderborad"
                        class="dark-color link-no-underline">
                        <span class="material-symbols-outlined">equalizer</span>
                        <span class="sidebar__menu-title"> Leaderboard</span>
                        </a>
                </li>
                <li *ngIf="activationInfo.programActivationId == '675c24c2bcfa6a0e5ccf5226' && user.organization == 'NUVOCO'">
                    <a href="https://atomV2.centumlearnpro.in/login?username={{user.email}}&clientid=20048&Source=AutoLogin" target="_blank" (click)="faqClick()"
                        class="dark-color link-no-underline"><span class="material-symbols-outlined">open_in_new</span>
                        <span class="sidebar__menu-title">ProficioAI (Simulation)</span></a>
                </li>
                <li>
                    <a href="https://programs.harappa.education/hc/en-us" target="_blank" (click)="faqClick()"
                        class="dark-color link-no-underline"><span class="material-symbols-outlined">help</span>
                        <span class="sidebar__menu-title">FAQs</span></a>
                </li>
                <li *ngIf="isHiration" [ngClass]="{'disabled': hirationData && hirationData?.status?.islock}">
                    <a routerLinkActive="active_menu" (click)="navHiration('dashboard/hiration')"
                        [class.active_menu]="isHirationTab" class="dark-color link-no-underline d-block cursor-pointer">
                        <span class="material-symbols-outlined">app_badging</span>
                        <span class="sidebar__menu-title">Resume Builder Tool</span>

                        </a>
                </li>

                <!-- assessment nav start -->
                <li *ngFor="let assessment of assessmentData">
                    <a routerLinkActive="active_menu" (click)="navigateToAssessment(assessment)"
                        [class.active_menu]="isAssessment" class="dark-color link-no-underline d-block cursor-pointer">
                        <span class="material-symbols-outlined">app_badging</span>
                        <span class="sidebar__menu-title">{{assessment.title}}</span>


                    </a>
                </li>
                <!-- assessment nav end -->

                <!-- Reports List starts -->

                <li *ngIf="reportMenu.length>0">
                    <a routerLinkActive="active_menu" routerLink="/dashboard/reports"
                        class="dark-color link-no-underline d-block">
                        <span class="material-symbols-outlined">app_badging</span>

                        <span class="sidebar__menu-title">Reports</span>
                        </a>
                </li>

                <!-- Reports List ends -->

                <!-- 1 to 1 report starts -->

                <li *ngIf="oneMenu.length>0">
                    <a routerLinkActive="active_menu" routerLink="/dashboard/sessions"
                        class="dark-color link-no-underline d-block"><span
                            class="material-symbols-outlined">app_badging</span>

                        <span class="sidebar__menu-title">1 to 1 Sessions</span>
                        </a>
                </li>
                <!-- 1to1 report ends -->

                <li class="show-on-mobile">
                    <a *ngIf="showHeaderDropdown" routerLinkActive="active_menu" id="showProgNav"
                        (click)="showProgNav()" class="dark-color link-no-underline d-flex"><span
                            class="material-symbols-outlined">app_badging</span>

                        <span class="sidebar__menu-title">All Courses/Programs</span>
                        </a>
                </li>

                <!-- Test Li -->

                <ng-container *ngFor="let menu of additionalMenu">
                    <li>
                        <a routerLinkActive="active_menu" (click)="testnewtab(menu?.url)" target="_blank"
                            class="dark-color link-no-underline d-flex custom-pointer">
                            <span class="material-symbols-outlined">
                              app_badging
                              </span>
                            <span class="sidebar__menu-title">{{menu?.label}}</span>
                          </a>
                    </li>
                </ng-container>

                <!-- Test Li end -->

                <!-- <li  >
                    <a href="javascript:void(0)" (click)="navigateTo('dashboard/leaderborad')"
                    [ngClass]="{'active_menu':(urlOnclick == 'dashboard/leaderborad')}"
                        class="dark-color link-no-underline d-block">Leaderboard</a>
                </li> -->
            </ul>
            <ul class="sidebar__menu list-none sidebar_belowmenu cursor-pointer">
                <li class="sidebar_belowmenu--logo">
                    <a (click)="navigateToDashboard()">
                        <!-- <img src="assets/images/revamp/sidebar_logo.png" alt="Logo"  /> -->
                        <img class="small-logo" src="assets/images/upgradRed/upgradEnterpriseSmallLogo.png" alt="Logo"  />
                        <img width="107" class="large-logo" src="assets/images/upgradRed/upgradEntLoginLogo.png" alt="Logo"  />
                    </a>
                </li>
                <li>
                    <a class="sidebar__menu--logout link-no-underline cursor-pointer" (click)="logout()">
                        <span class="material-symbols-outlined">logout</span>
                        <span class="sidebar__menu-title">Logout</span>
                        </a>
                </li>
            </ul>
            <!-- <a class="sidebar__menu--logout link-no-underline pd-l30 cursor-pointer" (click)="logout()">
                <span class="material-symbols-outlined">logout</span>
                Logout</a> -->
        </div>
        <!-- <div class="light-bg sidebar__wrapper d-none d-sm-block">
            <div class="sidebar__user d-flex align-items-center ">
                <div class="sidebar__profile--pic mg-r10">
                    <img [src]="user?.profilePic ? user?.profilePic : '/assets/images/user.png'" alt=""
                        class="sidebar__user--img" />
                </div>
                <div>
                    <p class="sidebar__user--name dark-color">{{user?.name}}</p>
                    <a routerLink="/dashboard/profile" (click)="closesidebarMobile()"
                        class="sidebar__user--link link-no-underline primary-color">View
                        Profile</a>
                </div>
            </div>
            <ul class="sidebar__menu list-none">
                <li (click)="closesidebarMobile()">
                    <a routerLink="/dashboard" routerLinkActive="active_menu" [routerLinkActiveOptions]="{exact: true}"
                        class="dark-color link-no-underline d-block">Dashboard</a>
                </li>
                <li (click)="closesidebarMobile()">
                    <a [routerLink]="['habit-drills']" routerLinkActive="active_menu"
                        class="dark-color link-no-underline d-block">Habit
                        Drills</a>
                </li>
                <li (click)="closesidebarMobile()">
                    <p>{{storeData?.data?.programActivationId}}</p>
                    <a routerLink="/dashboard/notes-bookmarks" routerLinkActive="active_menu"
                        class="dark-color link-no-underline d-block">Notes & Bookmarks</a>
                </li>
            </ul>
            <ul class="sidebar__menu list-none sidebar_belowmenu">
                <hr class="sidebar_belowmenu--border">
                <li (click)="closesidebarMobile()">
                    <a href="https://programs.harappa.education/hc/en-us" target="_blank"
                        class="dark-color link-no-underline d-block">FAQ’s</a>
                </li>
            </ul>
            <a class="sidebar__menu--logout primary-color link-no-underline pd-l30 cursor-pointer"
                (click)="logout()">LOGOUT</a>
        </div> -->
    </div>
</aside>
<!--  / sidebar \ -->
<div id="program__nav">
    <div class="progm__detail-wrap">
        <a (click)="closeProgNav()" class="progm__close"><i class="icon-nav font-16 icon-close"></i></a>
        <h2>All Programs/Courses<br></h2>
        <div class="progm__tabs">
            <div class="progm__tab" *ngIf="ipjPrograms.length>0">
                <label class="progm__tab-label">Integrated Programs</label>
                <div class="progm__tab-content">
                    <div *ngFor="let program of ipjPrograms">
                        <div class="tab-prog" (click)="loadNewIpjProgram(program)">
                            <div class="tab-img">
                                <img [src]="program?.logo" alt="" />
                            </div>
                            <div class="tab-text">
                                {{program.title}}
                            </div>
                            <div *ngIf="program.isActive" class="tab-icon">
                                <!-- <i class="fa fa-check"></i> -->
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="progm__tab" *ngIf="legacyPrograms.length>0">
                <label class="progm__tab-label">Old Programs/Courses</label>
                <div class="progm__tab-content">

                    <div *ngFor="let legacy of legacyPrograms">
                        <div class="tab-prog" (click)="sendToBusiness(legacy.link)">
                            <div class="tab-img">
                                <img [src]="legacy?.logo" alt="" />
                            </div>
                            <div class="tab-text">
                                {{legacy.title}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>

<!-- optional popover on assessment click -->
<app-optional-item-popover *ngIf="optionalModal" (skipItem)="skipOptionalBlock($event)"
    (startCurrentItem)="startCurrentBlockItem($event)" (hideOptionalModal)="optionalModalHide($event)">
</app-optional-item-popover>
